<template>
<div></div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import getWechatCodeHelper from '@/helpers/getWechatCodeHelper';

export default {  
  created() {
    if (getWechatCodeHelper.getUrlCode('code')) {
      const code = getWechatCodeHelper.getUrlCode('code');
      QuestionQuery.bindWechat(code).then(() => {
        this.$router.push({
          path: '/userCenter'
        });
      },
      (err) => {
        this.$router.push({
          path: '/userCenter'
        });
        this.$message({
          message: err.response.data.message,
          type: 'error'
        });
      });
    }
  }
};
</script>

